import queryString from 'query-string'
import apiClient from './api-client'

function getPatients({
  page,
  pageSize,
  approved,
  practiceId,
  showInactive,
  hasDeviceWarnings,
  q,
  deviceTypeId,
  deviceModelManufacturer,
  medicalProviderId,
  enrolled,
  monitoring,
  paired,
  birthDate,
  officeLocationId,
  includeNonCurrentDevices,
}) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: 'patients',
      query: {
        page,
        per_page: pageSize,
        approved,
        practice_id: practiceId,
        device_type_id: deviceTypeId,
        device_model_manufacturer: deviceModelManufacturer,
        medical_provider_id: medicalProviderId,
        enrolled,
        paired,
        monitoring,
        // avoid sending when false (string false is also truthy)
        show_inactive: showInactive || undefined,
        has_device_warnings: hasDeviceWarnings || undefined,
        include_non_current_devices: includeNonCurrentDevices || undefined,
        birth_date: birthDate,
        q,
        office_location_id: officeLocationId,
      },
    }),
    { withHeaders: true },
  )
}

function get(id) {
  return apiClient.get(`patients/${id}`)
}

function getAlerts(id, query) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: `patients/${id}/alerts`,
      query,
    }),
    { withHeaders: true },
  )
}

function getReports(id, query, limit = 25, additionalParams = {}) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: `patients/${id}/reports`,
      query: {
        per_page: limit,
        page: additionalParams.page || 1,
        query,
        ...additionalParams,
      },
    }),
    { withHeaders: true },
  )
}

function getOfficeChecks(practiceId, id, query) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: `practices/${practiceId}/office-checks`,
      query: {
        ...query,
        patient_id: id,
      },
    }),
    { withHeaders: true },
  )
}

function getMissedTransmissions(id, limit = 25, page = 1) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: `missed-transmissions`,
      query: {
        patient_id: id,
        per_page: limit,
        page,
      },
    }),
    { withHeaders: true },
  )
}

function getTransmissions(id, limit = 25, page = 1) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: `v2/patients/${id}/transmissions`,
      query: {
        per_page: limit,
        page,
      },
    }),
    { withHeaders: true },
  )
}

function getUnapprovedCount() {
  return apiClient.get('patients/unapproved/count')
}

function create(patient) {
  return apiClient.post('patients', patient)
}

function update(id, patientData) {
  return apiClient.patch(`patients/${id}`, patientData)
}

function destroy(id, params = {}) {
  return apiClient.destroy(`patients/${id}`, { body: params })
}

function createDevice(patientId, deviceData) {
  return apiClient.post(`patients/${patientId}/devices`, deviceData)
}

function getDevices(patientId) {
  return apiClient.get(`patients/${patientId}/devices`)
}

function fullRemoval(id) {
  return apiClient.destroy(`patients/${id}/destroy`)
}

function remind(ids, type) {
  let reminderType = type

  if (type !== 'voice' && type !== 'sms') {
    reminderType = 'sms'
  }

  return apiClient.post('/reminders', { patient_ids: ids, type: reminderType })
}

function savePreferences(id, preferences) {
  return apiClient.post(`/patients/${id}/preferences`, preferences)
}
function sendWelcomeLetter(id) {
  return apiClient.post(`/patients/${id}/welcome_letter`)
}

function getExcelStatus(fileId) {
  return apiClient.get(`/patients/exports/${fileId}`)
}

function getRemoteChecks(id, query) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: `/v2/remote-checks`,
      query: {
        patient_id: id,
        ...query,
      },
    }),
    { withHeaders: true },
  )
}

const Patients = {
  create,
  createDevice,
  destroy,
  fullRemoval,
  get,
  getDevices,
  getAlerts,
  getPatients,
  getReports,
  getOfficeChecks,
  getMissedTransmissions,
  getUnapprovedCount,
  update,
  remind,
  savePreferences,
  sendWelcomeLetter,
  getExcelStatus,
  getTransmissions,
  getRemoteChecks,
}

export default Patients
